import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import InputTextMat from "../../../../components/common/InputText/InputTextMatWithClose";
import IconImage from ".//..//..//..//..//assets//images//icons//image.png";
import IconPdf from ".//..//..//..//..//assets//images//icons//pdf.svg";
import ButtonOutlineFluid from "../../../../components/common/buttons/ButtonOutlineFluid";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import SquareRound from ".//..//..//..//..//assets//images//icons//square-rounded.svg";
import ConditionLabel from "../../../../components/calculator/ConditionLabel/ConditionLabel";
import TextArea from "../../../../components/common/TextArea/TextArea";
import BackButton from "../../../../components/calculator/ConditionLabel/BackButton";
import { ROUTES } from "../../../../constants/Routes";
import StepBar from "../../../../components/calculator/Wizard/StepBar";
import Button from "../../../../components/common/buttons/Button";
import ArrowLeft from ".//..//..//..//..//assets//images//icons//arrow-left.svg";
import CheckBox from "../../../../components/common/checkbox/CheckboxSmallWithoutLabel";
import InputTextSimpleSmall from "../../../../components/common/InputText/InputTextSimpleSmall";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import useAuth from "../../../../hooks/useAuth";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { ProposalSummaryDataActions } from "../../../../store/Slice/SummeryDataSlice";
import Calculations from "./Calculations";
import InputNumbersIntSimple from "../../../../components/common/InputText/InputNumbersIntSimple";
import InputNumbersSimple from "../../../../components/common/InputText/InputNumbersSimple";

const KalkulacioOsszegzes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const apiBasePath = process.env.REACT_APP_API_PATH;

  const searchParams = new URLSearchParams(location.search);
  const proposalId = searchParams.get("p-id");

  const [step, setStep] = useState(6);
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const [proposalKey, setProposalKey] = useState("");
  const dispatch = useDispatch();

  const proposalData = useSelector((state) => state.proposalSummary.proposalData);
  const proposalTourPlan = useSelector((state) => state.proposalSummary.proposalTourPlan);
  const proposalItems = useSelector((state) => state.proposalSummary.proposalItems);
  const proposalLogistic = useSelector((state) => state.proposalSummary.proposalLogistic);

  const proposalPkMaterials = useSelector((state) => state.proposalSummary.proposalPkMaterials);
  const fees = useSelector((state) => state.proposalSummary.fees);

  const transactionFees = useSelector((state) => state.proposalSummary.transactionFees);

  const summeryData = useSelector((state) => state.proposalSummary.summeryData);

  const { getAuth, clearAuth } = useAuth();
  //------------------------------
  const [jarmu_szukseglet, setJarmuSzukseglet] = useState(0);
  const [munkaero_szukseglet, setMunkaeroSzukseglet] = useState(0);
  const [tavolsag, setTavolsag] = useState(0);
  const [terfogat, setTerfogat] = useState(0);
  const [alacsony_ar, setAlacsonyAr] = useState(0);
  const [utvonal_ar, setUtvonalAr] = useState(0);
  const [stop_ar, setStopAr] = useState(0);
  const [nincs_zone_ar, setNincsZoneAr] = useState(0);
  const [bonstasi_ar, setBonstasiAr] = useState(0);
  const [telepitesi_ar, setTelepitesiAr] = useState(0);
  const [csomagolasi_ar, setCsomagolsiAr] = useState(0);
  const [buborekfolio_ar, setBuborekfolioAr] = useState(0);
  const [nehez_rakomany_ar, setNehezRakomanyAr] = useState(0);
  const [butoremelo_ar, setButoremeloAr] = useState(0);
  const [kulso_lift_ar, setKulsoLiftAr] = useState(0);
  const [bolti_ar, setBoltiAr] = useState(0);
  const [szemelyzeti_ar, setSzemelyzetiAr] = useState(0);
  const [konyhaszerelo_ar, setKonyhaszereloAr] = useState(0);
  const [kuchenmonteur_ar, setKuchenmonteurAr] = useState(0);
  const [villanyszerelo_ar, setVillanyszereloAr] = useState(0);
  const [teljes_ar, setTeljesAr] = useState(0);
  const [kedvezmeny, setKedvezmeny] = useState(0);
  const [osszesen, setOsszesen] = useState(0);
  const [megjegyes, setMegjegyes] = useState("");
  const [tetelAr, setTetalAr] = useState(0);
  const [tarolasi_ar, setTarolasiAr] = useState(0);

  const [verpackungsmaterial_ar, setVerpackungsmaterialAr] = useState(0);

  //---
  const [jarmu_szukseglet_checked, setJarmuSzuksegletChecked] = useState(0);
  const [munkaero_szukseglet_checked, setMunkaeroSzuksegletChecked] = useState(0);
  const [tavolsag_checked, setTavolsagChecked] = useState(false);
  const [terfogat_checked, setTerfogatChecked] = useState(0);
  const [alacsony_ar_checked, setAlacsonyArChecked] = useState(0);
  const [utvonal_ar_checked, setUtvonalArChecked] = useState(0);
  const [stop_ar_checked, setStopArChecked] = useState(0);
  const [nincs_zone_ar_checked, setNincsZoneArChecked] = useState(0);
  const [bonstasi_ar_checked, setBonstasiArChecked] = useState(0);
  const [telepitesi_ar_checked, setTelepitesiArChecked] = useState(0);
  const [csomagolasi_ar_checked, setCsomagolsiArChecked] = useState(0);
  const [buborekfolio_ar_checked, setBuborekfolioArChecked] = useState(0);
  const [nehez_rakomany_ar_checked, setNehezRakomanyArChecked] = useState(0);
  const [butoremelo_ar_checked, setButoremeloArChecked] = useState(0);
  const [kulso_lift_ar_checked, setKulsoLiftArChecked] = useState(0);
  const [bolti_ar_checked, setBoltiArChecked] = useState(0);
  const [szemelyzeti_ar_checked, setSzemelyzetiArChecked] = useState(0);
  const [konyhaszerelo_ar_checked, setKonyhaszereloArChecked] = useState(0);
  const [kuchenmonteur_ar_checked, setKuchenmonteurArChecked] = useState(0);
  const [villanyszerelo_ar_checked, setVillanyszereloArChecked] = useState(0);
  const [teljes_ar_checked, setTeljesArChecked] = useState(false);
  const [kedvezmeny_checked, setKedvezmenyChecked] = useState(false);
  const [osszesen_checked, setOsszesenChecked] = useState(false);
  const [tetal_ar_checked, setTetelArChecked] = useState(false);
  const [verpackungsmaterial_ar_checked, setVerpackungsmaterialArChecked] = useState(false);

  const [tarolasi_ar_checked, setTarolasiArChecked] = useState(false);

  const [extraSerice, setExtraService] = useState(0);
  const [extraServiceFee, setExtraServiceFee] = useState(0);
  const [extraSericeChecked, setExtraServiceChecked] = useState(0);
  //-------------------------------
  const [streetViewImages, setStreetViewImages] = useState([]);

  const fetchSummaryData = () => {
    setSpinnerVisible(true);
    HttpHelper.GetRequest({
      route: `${API_ROUTES.PR_TOURPLAN_SUMMERY_DATA}?proposal_id=${proposalId}`,
      token: getAuth()?.bearerToken,
    })
      .then((data) => {
        if (data.status == 200) {
          const proposalData = data?.data?.proposalData;
          const proposalItems = data?.data?.proposalItems;
          const proposalLogistic = data?.data?.proposalLogistic;
          const proposalTourPlan = data?.data?.proposalTourPlan;
          const fees = data?.data?.fees;
          const transportFees = data?.data?.transportFees;
          const summeryData = data?.data?.summeryData;
          const stImage = data?.data?.stImage;
          const proposalPkMaterials = data?.data?.proposalPkMaterials;
          setProposalKey(proposalData[0]?.proposal_number);
          setStreetViewImages(stImage);
          dispatch(
            ProposalSummaryDataActions.setSummeryInitState({
              proposalData,
              proposalItems,
              proposalLogistic,
              proposalTourPlan,
              fees,
              transportFees,
              summeryData,
              proposalPkMaterials,
            })
          );
          let exService = "";
          let exServiceFee = 0;

          if (proposalLogistic[0]?.plusz_szolgaltatas != null) {
            exService = proposalLogistic[0]?.plusz_szolgaltatas;
            exServiceFee = proposalLogistic[0]?.plusz_szolgaltatas_cost;
            setExtraService(exService);
            setExtraServiceFee(parseFloat(exServiceFee).toFixed(2));
          }
          setSpinnerVisible(false);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else if (data.status == 500) {
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        } else {
          toast.error("Unknown server error 1!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Unknown server error 2!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setSpinnerVisible(false);
      });
  };

  useEffect(() => {
    if (summeryData.length > 0) {
      setTavolsagChecked(summeryData[0]?.tavolsag_checked == 0 ? false : true);
      setTerfogatChecked(summeryData[0]?.terfogat_checked == 0 ? false : true);
      setAlacsonyArChecked(summeryData[0]?.alacsony_ar_checked == 0 ? false : true);
      setUtvonalArChecked(summeryData[0]?.utvonal_ar_checked == 0 ? false : true);
      setStopArChecked(summeryData[0]?.stop_ar_checked == 0 ? false : true);
      setNincsZoneArChecked(summeryData[0]?.nincs_zone_ar_checked == 0 ? false : true);
      setBonstasiArChecked(summeryData[0]?.bonstasi_ar_checked == 0 ? false : true);
      setTelepitesiArChecked(summeryData[0]?.telepitesi_ar_checked == 0 ? false : true);
      setCsomagolsiArChecked(summeryData[0]?.csomagolasi_ar_checked == 0 ? false : true);
      setBuborekfolioArChecked(summeryData[0]?.buborekfolio_ar_checked == 0 ? false : true);
      setNehezRakomanyArChecked(summeryData[0]?.nehez_rakomany_ar_checked == 0 ? false : true);
      setButoremeloArChecked(summeryData[0]?.butoremelo_ar_checked == 0 ? false : true);
      setKulsoLiftArChecked(summeryData[0]?.kulso_lift_ar_checked == 0 ? false : true);
      setBoltiArChecked(summeryData[0]?.bolti_ar_checked == 0 ? false : true);
      setSzemelyzetiArChecked(summeryData[0]?.szemelyzeti_ar_checked == 0 ? false : true);
      setKonyhaszereloArChecked(summeryData[0]?.konyhaszerelo_ar_checked == 0 ? false : true);
      setVillanyszereloArChecked(summeryData[0]?.villanyszerelo_ar_checked == 0 ? false : true);
      setTeljesArChecked(summeryData[0]?.teljes_ar_checked == 0 ? false : true);
      setKedvezmenyChecked(summeryData[0]?.kedvezmeny_checked == 0 ? false : true);
      setOsszesenChecked(summeryData[0]?.osszesen_checked == 0 ? false : true);
      setKedvezmeny(summeryData[0]?.kedvezmeny);
      setTetelArChecked(summeryData[0]?.tetal_ar_checked == 0 ? false : true);
      setExtraServiceChecked(summeryData[0]?.extra_service_checked == 0 ? false : true);
      setTarolasiArChecked(summeryData[0]?.tarolasi_checked == 0 ? false : true);
      setVerpackungsmaterialArChecked(summeryData[0]?.verpackungsmaterial_ar_checked);

      setKuchenmonteurArChecked(summeryData[0]?.kuchenmonteur_checked == 0 ? false : true);
      setMegjegyes(summeryData[0]?.megjegyes == null ? "" : summeryData[0]?.megjegyes);
    }
  }, [summeryData]);

  useEffect(() => {
    if (proposalLogistic.length > 0 && fees.length > 0) {
      console.log(proposalLogistic);
      const butorlift = proposalLogistic[0]?.butorlift;
      const kulso_lift_kezelovel = proposalLogistic[0]?.kulso_lift_kezelovel;
      const villanyszerelo = proposalLogistic[0]?.villanyszerelo;

      const butoremeloAr = butorlift * fees[0]?.mobel_stecklift;
      const kulsoLiftKezelovelAr = kulso_lift_kezelovel * fees[0]?.aubenaufzug_inkl_bediener;
      const villanyszereloAr = villanyszerelo * 4 * fees[0]?.elektriker_euro_std;

      setButoremeloAr(parseFloat(butoremeloAr).toFixed(2));
      setKulsoLiftAr(parseFloat(kulsoLiftKezelovelAr).toFixed(2));
      // setVillanyszereloAr(parseFloat(villanyszereloAr).toFixed(2));
    }
  }, [proposalLogistic, fees]);

  useEffect(() => {
    fetchSummaryData();
  }, []);

  const findJarmuSzuksegletCount = (proposalLogistic) => {
    const jarmu_szukseglet = Calculations.findJarmuSzuksegletCount(proposalLogistic);
    setJarmuSzukseglet(jarmu_szukseglet);
  };

  useEffect(() => {
    if (proposalTourPlan?.length > 0) {
      // set tavlsag - total distance
      const tavolsag = Calculations.findTavolsag(proposalTourPlan);
      setTavolsag(tavolsag);
      // set utvonal - route fees
    }

    if (proposalLogistic?.length > 0) {
      console.log(proposalLogistic[0]);
      findJarmuSzuksegletCount(proposalLogistic[0]);
      // setMunkaeroSzukseglet(proposalLogistic[0]?.munkaero);
      const tMunkaero = Calculations.findTotalMunkaeroSzukseglet(proposalLogistic);
      setMunkaeroSzukseglet(tMunkaero);
    }

    const alacsonyAr = Calculations.fintAlaconyCost(proposalTourPlan, proposalItems, fees);
    setAlacsonyAr(parseFloat(alacsonyAr).toFixed(2));

    //utvonal - transport fees
    const utvonal = Calculations.findUtvonal(proposalTourPlan, transactionFees, fees, proposalItems);
    setUtvonalAr(parseFloat(utvonal).toFixed(2));

    //tetal Ar
    const tetalAr = Calculations.findTetalAr(proposalItems, fees);
    setTetalAr(parseFloat(tetalAr).toFixed(2));

    // stop Ar - stop fees
    const stopAr = Calculations.findStopAr(proposalTourPlan, fees);
    setStopAr(stopAr.toFixed(2));

    const nincsAr = Calculations.findNincsAr(proposalTourPlan, fees);
    setNincsZoneAr(nincsAr.toFixed(2));

    const tarrolasiAr = Calculations.findtarolasiAr(proposalItems, fees, proposalLogistic);
    setTarolasiAr(tarrolasiAr);

    const kuchenmonteurAr = Calculations.findKuchenmonteurAr(proposalLogistic, fees);
    //  setKuchenmonteurAr(kuchenmonteurAr.toFixed(2));

    if (proposalItems.length > 0) {
      const terfogat = Calculations.findTerfogat(proposalItems);
      setTerfogat(parseFloat(terfogat).toFixed(2));

      const { VillanyszereloAr, KonyhaszereloAr, SzemelyzetiAr } = Calculations.findKoyhasAndVillanysZerelo(
        proposalItems,
        fees,
        proposalLogistic
      );

      const SzemelyzetiArNew = Calculations.findSzemelyzetiArNew(proposalTourPlan, proposalLogistic);
      setKuchenmonteurAr(KonyhaszereloAr.toFixed(2));
      //  setKonyhaszereloAr(KonyhaszereloAr);
      setVillanyszereloAr(parseFloat(VillanyszereloAr).toFixed(2));
      setSzemelyzetiAr(parseFloat(SzemelyzetiArNew));

      const productCost = Calculations.findProductCost(proposalItems, fees);
      setBonstasiAr(parseFloat(productCost.bontasi_ar).toFixed(2));
      setTelepitesiAr(productCost.telepitesi_ar.toFixed(2));
      setCsomagolsiAr(productCost.csomagolasi_ar.toFixed(2));
      setBuborekfolioAr(parseFloat(productCost.buborekfolio_ar).toFixed(2));
      setNehezRakomanyAr(productCost.nehez_rakomany_ar.toFixed(2));
      setBoltiAr(parseFloat(productCost?.bolti_ar).toFixed(2));

      findOSszesen();
    }
  }, [proposalTourPlan, fees, transactionFees, proposalLogistic, proposalItems]);

  const findOSszesen = () => {
    const teljesAr =
      alacsony_ar * 1 +
      utvonal_ar * 1 +
      stop_ar * 1 +
      nincs_zone_ar * 1 +
      bonstasi_ar * 1 +
      telepitesi_ar * 1 +
      csomagolasi_ar * 1 +
      buborekfolio_ar * 1 +
      nehez_rakomany_ar * 1 +
      butoremelo_ar * 1 +
      kulso_lift_ar * 1 +
      bolti_ar * 1 +
      szemelyzeti_ar * 1 +
      // konyhaszerelo_ar * 1 +
      kuchenmonteur_ar * 1 +
      tetelAr * 1 +
      villanyszerelo_ar * 1 +
      extraServiceFee * 1 +
      verpackungsmaterial_ar * 1 +
      tarolasi_ar * 1;

    setTeljesAr(teljesAr.toFixed(2));
    const osszesen_ar = teljesAr - (kedvezmeny * teljesAr) / 100;
    setOsszesen((osszesen_ar * 1).toFixed(2));
  };

  useEffect(() => {
    if (kedvezmeny > 100) {
      setKedvezmeny(100);
    }
    findOSszesen();
  }, [
    alacsony_ar,
    utvonal_ar,
    stop_ar,
    nincs_zone_ar,
    bonstasi_ar,
    telepitesi_ar,
    csomagolasi_ar,
    buborekfolio_ar,
    nehez_rakomany_ar,
    butoremelo_ar,
    kulso_lift_ar,
    bolti_ar,
    szemelyzeti_ar,
    konyhaszerelo_ar,
    tetelAr,
    villanyszerelo_ar,
    verpackungsmaterial_ar,
    kedvezmeny,
    extraServiceFee,
  ]);

  useEffect(() => {
    console.log(proposalPkMaterials);
    let pkTotal = 0;
    proposalPkMaterials.map((item, index) => {
      pkTotal += item?.zwischensum * 1;
    });
    setVerpackungsmaterialAr(pkTotal.toFixed(2));
  }, [proposalPkMaterials]);

  const saveSummaryData = () => {
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_TOURPLAN_SUMMERY_DATA_SAVE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposal_id: proposalId,
        jarmu_szukseglet,
        munkaero_szukseglet,
        tavolsag,
        terfogat,
        alacsony_ar,
        utvonal_ar,
        stop_ar,
        tetal_ar: tetelAr,
        tetal_ar_checked,
        nincs_zone_ar,
        bonstasi_ar,
        telepitesi_ar,
        csomagolasi_ar,
        buborekfolio_ar,
        nehez_rakomany_ar,
        butoremelo_ar,
        kulso_lift_ar,
        bolti_ar,
        szemelyzeti_ar,
        konyhaszerelo_ar,
        villanyszerelo_ar,
        teljes_ar,
        kedvezmeny,
        osszesen,
        megjegyes,
        kuchenmonteur_ar,

        verpackungsmaterial_ar,
        tavolsag_checked,
        terfogat_checked,
        alacsony_ar_checked,
        utvonal_ar_checked,
        stop_ar_checked,
        nincs_zone_ar_checked,
        bonstasi_ar_checked,
        telepitesi_ar_checked,
        csomagolasi_ar_checked,
        buborekfolio_ar_checked,
        nehez_rakomany_ar_checked,
        butoremelo_ar_checked,
        kulso_lift_ar_checked,
        bolti_ar_checked,
        szemelyzeti_ar_checked,
        konyhaszerelo_ar_checked,
        villanyszerelo_ar_checked,
        teljes_ar_checked,
        kedvezmeny_checked,
        osszesen_checked,
        megjegyes,
        verpackungsmaterial_ar_checked,
        kuchenmonteur_ar_checked,

        extra_service: extraSerice,
        extra_service_ar: extraServiceFee,
        extra_service_checked: extraSericeChecked,
        tarolasi_ar: tarolasi_ar,
        tarolasi_checked: tarolasi_ar_checked,
      },
    })
      .then((res) => {
        if (res?.status === 200) {
          toast.success("Javaslat sikeresen mentve.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate(`${ROUTES.CAL_LIST}`);
        } else if (res.status === 422) {
          toast.error(" Hiba, a javaslat összefoglaló adatai nem lettek mentve!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        toast.error(" Hiba, a javaslat összefoglaló adatai nem lettek mentve!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const saveSummaryDataAndDownload = () => {
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_TOURPLAN_SUMMERY_DATA_SAVE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposal_id: proposalId,
        jarmu_szukseglet,
        munkaero_szukseglet,
        tavolsag,
        terfogat,
        alacsony_ar,
        utvonal_ar,
        stop_ar,
        tetal_ar: tetelAr,
        tetal_ar_checked,
        nincs_zone_ar,
        bonstasi_ar,
        telepitesi_ar,
        csomagolasi_ar,
        buborekfolio_ar,
        nehez_rakomany_ar,
        butoremelo_ar,
        kulso_lift_ar,
        bolti_ar,
        szemelyzeti_ar,
        konyhaszerelo_ar,
        villanyszerelo_ar,
        teljes_ar,
        kedvezmeny,
        osszesen,
        megjegyes,
        kuchenmonteur_ar,

        verpackungsmaterial_ar,
        tavolsag_checked,
        terfogat_checked,
        alacsony_ar_checked,
        utvonal_ar_checked,
        stop_ar_checked,
        nincs_zone_ar_checked,
        bonstasi_ar_checked,
        telepitesi_ar_checked,
        csomagolasi_ar_checked,
        buborekfolio_ar_checked,
        nehez_rakomany_ar_checked,
        butoremelo_ar_checked,
        kulso_lift_ar_checked,
        bolti_ar_checked,
        szemelyzeti_ar_checked,
        konyhaszerelo_ar_checked,
        villanyszerelo_ar_checked,
        teljes_ar_checked,
        kedvezmeny_checked,
        osszesen_checked,
        megjegyes,
        verpackungsmaterial_ar_checked,
        kuchenmonteur_ar_checked,

        extra_service: extraSerice,
        extra_service_ar: extraServiceFee,
        extra_service_checked: extraSericeChecked,

        tarolasi_ar: tarolasi_ar,
        tarolasi_checked: tarolasi_ar_checked,
      },
    })
      .then((res) => {
        if (res?.status === 200) {
          toast.success("Javaslat sikeresen mentve.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          window.open(`${apiBasePath}/invoice?invoiceid=${proposalId}`, "_blank", "noopener,noreferrer");
        } else if (res.status === 422) {
          toast.error(" Hiba, a javaslat összefoglaló adatai nem lettek mentve!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        toast.error(" Hiba, a javaslat összefoglaló adatai nem lettek mentve!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const saveSummeryAndNewPropoposal = () => {
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_TOURPLAN_SUMMERY_DATA_SAVE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposal_id: proposalId,
        jarmu_szukseglet,
        munkaero_szukseglet,
        tavolsag,
        terfogat,
        alacsony_ar,
        utvonal_ar,
        stop_ar,
        tetal_ar: tetelAr,
        tetal_ar_checked,
        nincs_zone_ar,
        bonstasi_ar,
        telepitesi_ar,
        csomagolasi_ar,
        buborekfolio_ar,
        nehez_rakomany_ar,
        butoremelo_ar,
        kulso_lift_ar,
        bolti_ar,
        szemelyzeti_ar,
        konyhaszerelo_ar,
        villanyszerelo_ar,
        teljes_ar,
        kedvezmeny,
        osszesen,
        megjegyes,
        kuchenmonteur_ar,

        verpackungsmaterial_ar,
        tavolsag_checked,
        terfogat_checked,
        alacsony_ar_checked,
        utvonal_ar_checked,
        stop_ar_checked,
        nincs_zone_ar_checked,
        bonstasi_ar_checked,
        telepitesi_ar_checked,
        csomagolasi_ar_checked,
        buborekfolio_ar_checked,
        nehez_rakomany_ar_checked,
        butoremelo_ar_checked,
        kulso_lift_ar_checked,
        bolti_ar_checked,
        szemelyzeti_ar_checked,
        konyhaszerelo_ar_checked,
        villanyszerelo_ar_checked,
        teljes_ar_checked,
        kedvezmeny_checked,
        osszesen_checked,
        megjegyes,
        verpackungsmaterial_ar_checked,
        kuchenmonteur_ar_checked,

        extra_service: extraSerice,
        extra_service_ar: extraServiceFee,
        extra_service_checked: extraSericeChecked,

        tarolasi_ar: tarolasi_ar,
        tarolasi_checked: tarolasi_ar_checked,
      },
    })
      .then((res) => {
        if (res?.status === 200) {
          toast.success("Javaslat sikeresen mentve.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate(ROUTES.CAL_MANAGE_CUSTOMER_DATA_CREATE);
        } else if (res.status === 422) {
          toast.error(" Hiba, a javaslat összefoglaló adatai nem lettek mentve!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        toast.error(" Hiba, a javaslat összefoglaló adatai nem lettek mentve!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const saveSummeryAndFinish = () => {
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_TOURPLAN_SUMMERY_DATA_SAVE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposal_id: proposalId,
        jarmu_szukseglet,
        munkaero_szukseglet,
        tavolsag,
        terfogat,
        alacsony_ar,
        utvonal_ar,
        stop_ar,
        tetal_ar: tetelAr,
        tetal_ar_checked,
        nincs_zone_ar,
        bonstasi_ar,
        telepitesi_ar,
        csomagolasi_ar,
        buborekfolio_ar,
        nehez_rakomany_ar,
        butoremelo_ar,
        kulso_lift_ar,
        bolti_ar,
        szemelyzeti_ar,
        konyhaszerelo_ar,
        villanyszerelo_ar,
        teljes_ar,
        kedvezmeny,
        osszesen,
        megjegyes,
        kuchenmonteur_ar,

        verpackungsmaterial_ar,
        tavolsag_checked,
        terfogat_checked,
        alacsony_ar_checked,
        utvonal_ar_checked,
        stop_ar_checked,
        nincs_zone_ar_checked,
        bonstasi_ar_checked,
        telepitesi_ar_checked,
        csomagolasi_ar_checked,
        buborekfolio_ar_checked,
        nehez_rakomany_ar_checked,
        butoremelo_ar_checked,
        kulso_lift_ar_checked,
        bolti_ar_checked,
        szemelyzeti_ar_checked,
        konyhaszerelo_ar_checked,
        villanyszerelo_ar_checked,
        teljes_ar_checked,
        kedvezmeny_checked,
        osszesen_checked,
        megjegyes,
        verpackungsmaterial_ar_checked,
        kuchenmonteur_ar_checked,

        extra_service: extraSerice,
        extra_service_ar: extraServiceFee,
        extra_service_checked: extraSericeChecked,

        tarolasi_ar: tarolasi_ar,
        tarolasi_checked: tarolasi_ar_checked,
      },
    })
      .then((res) => {
        if (res?.status === 200) {
          completeProposal();
        } else if (res.status === 422) {
          toast.error(" Hiba, a javaslat összefoglaló adatai nem lettek mentve!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        toast.error(" Hiba, a javaslat összefoglaló adatai nem lettek mentve!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  const downloadBase64Image = (base64String, fileName) => {
    var a = document.createElement("a"); //Create <a>
    a.href = base64String; //Image Base64 Goes here
    a.download = `${fileName}.png`; //File name Here
    a.click(); //Downloaded file
  };

  const completeProposal = () => {
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_COMPLETE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposal_id: proposalId,
      },
    })
      .then((res) => {
        if (res?.status === 200) {
          toast.success("Javaslat állapotát sikeresen frissítették.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate(`${ROUTES.CAL_LIST}`);
        } else if (res.status === 422) {
          toast.error("Hiba, a javaslat állapota nem frissült.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        toast.error(" Hiba, a javaslat összefoglaló adatai nem lettek mentve!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  return (
    <>
      <div className="px-[1rem]  sm:px-[1.875rem] mt-[3rem] gap-3 grid grid-cols-2 md:grid-cols-[10rem_1fr_10rem] grid-rows-2 md:grid-rows-1">
        <div className="col-start-1 col-end-2 row-start-2 row-end-3 md:row-span-1 md:row-end-2 ">
          <div className="max-w-[10rem] me-auto">
            <Link to={`${ROUTES.CAL_MANAGE_LOGISTIC_DATA}?p-id=${proposalId}`}>
              <BackButton icon={ArrowLeft} label={"Vissza"} />
            </Link>
          </div>
        </div>
        <div className="w-full col-span-2 md:col-span-1 md:col-end-3 md:col-start-2 ">
          <StepBar currentStepNo={step} />
        </div>
        <div className="col-start-2 col-end-3 row-start-2 row-end-3 md:col-end-4 md:col-start-3 md:row-span-1 md:row-end-2 ">
          <div className="max-w-[10rem] ms-auto">
            <Button label={"Mentés"} onClick={saveSummaryData} />
          </div>
        </div>
      </div>
      <div className="px-[2rem] sm:px-[3.575rem] mt-[3.7rem] flex flex-col sm:items-center justify-between sm:flex-row gap-10">
        <div className="flex flex-row items-center justify-between gap-[1.5rem] w-full">
          <div className="flex flex-col">
            <span className="text-text-primary-color font-lato text-[1.3rem] md:text-[2rem] font-bold leading-[2.5rem]">
              Ajánlat száma: {proposalKey}
            </span>
          </div>
        </div>
      </div>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem] flex flex-col lg:flex-row gap-10">
        <div className="w-full lg:w-1/2">
          <ul className="flex flex-col gap-[1.25rem] mt-[1.25rem] px-[1.625rem] mb-[2rem] text-[1rem] font-lato font-bold">
            <li className="flex justify-between gap-2">
              <span className="w-full text-[1.5rem]"> Létszám szükséglet</span>
            </li>
          </ul>
          <ul className="flex flex-col gap-[1.25rem] mt-[1.25rem] px-[1.625rem] mb-[3.75rem] text-[1rem] font-lato font-bold">
            <li className="flex justify-between gap-2">
              <span className="w-full ">Jármű szükséglet</span>
              <span className="w-20 text-start ms-1">{jarmu_szukseglet}</span>
              <span className="w-20 break-all text-end ms-1">DB</span>
              <span className="flex items-center justify-end w-16"></span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Munkaerő szükséglet</span>
              <span className="w-20 text-start ms-1">{munkaero_szukseglet}</span>
              <span className="w-20 break-all text-end ms-1">DB</span>
              <span className="flex items-center justify-end w-16"></span>
            </li>
          </ul>
          <ul className="flex flex-col gap-[1.25rem] mt-[1.25rem] px-[1.625rem] mb-[2rem] text-[1rem] font-lato font-bold">
            <li className="flex justify-between gap-2">
              <span className="w-full text-[1.5rem]"> Felmerülő költségek</span>
              <span className="w-20 break-all text-end ms-1 -me-3">számla</span>
            </li>
          </ul>
          <ul className="flex flex-col gap-[1.25rem] mt-[1.25rem] px-[1.625rem] text-[1rem] font-lato font-bold">
            <li className="flex justify-between gap-2">
              <span className="w-full ">Távolság</span>
              <span className="w-20 text-start ms-1">{tavolsag}</span>
              <span className="w-20 break-all text-end ms-1">KM</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Távolság"}
                  checked={tavolsag_checked}
                  onChange={() => setTavolsagChecked(!tavolsag_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Térfogat</span>
              <span className="w-20 text-start ms-1">{terfogat}</span>
              <span className="w-20 break-all text-end ms-1">
                m<sup>3</sup>
              </span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Térfogat"}
                  checked={terfogat_checked}
                  onChange={() => setTerfogatChecked(!terfogat_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Emelet ár</span>
              <span className="w-20 text-start ms-1">{alacsony_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Alacsony ár"}
                  checked={alacsony_ar_checked}
                  onChange={() => setAlacsonyArChecked(!alacsony_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Útvonal ár</span>
              <span className="w-20 text-start ms-1">{utvonal_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Útvonal ár"}
                  checked={utvonal_ar_checked}
                  onChange={() => setUtvonalArChecked(!utvonal_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Stop ár</span>
              <span className="w-20 text-start ms-1">{stop_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Stop ár"}
                  checked={stop_ar_checked}
                  onChange={() => setStopArChecked(!stop_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Nincs megállási zóna (jóváhagyott, kialakított) ár</span>
              <span className="w-20 text-start ms-1">{nincs_zone_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Nincs megállási zóna "}
                  checked={nincs_zone_ar_checked}
                  onChange={() => setNincsZoneArChecked(!nincs_zone_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Bontási ár</span>
              <span className="w-20 text-start ms-1">{bonstasi_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Bontási ár "}
                  checked={bonstasi_ar_checked}
                  onChange={() => setBonstasiArChecked(!bonstasi_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Telepítési ár</span>
              <span className="w-20 text-start ms-1">{telepitesi_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Telepítési ár "}
                  checked={telepitesi_ar_checked}
                  onChange={() => setTelepitesiArChecked(!telepitesi_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full "> Csomagolási ár</span>
              <span className="w-20 text-start ms-1">{csomagolasi_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Csomagolási ár "}
                  checked={csomagolasi_ar_checked}
                  onChange={() => setCsomagolsiArChecked(!csomagolasi_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full "> Buborékfólia ár</span>
              <span className="w-20 text-start ms-1">{buborekfolio_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={" Buborékfólia ár"}
                  checked={buborekfolio_ar_checked}
                  onChange={() => setBuborekfolioArChecked(!buborekfolio_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Nehéz rakomány felár</span>
              <span className="w-20 text-start ms-1">{nehez_rakomany_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Nehéz rakomány felár"}
                  checked={nehez_rakomany_ar_checked}
                  onChange={() => setNehezRakomanyArChecked(!nehez_rakomany_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Bútoremelő ár</span>
              <span className="w-20 text-start ms-1">{butoremelo_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Bútoremelő ár"}
                  checked={butoremelo_ar_checked}
                  onChange={() => setButoremeloArChecked(!butoremelo_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Külső lift ára, kezelővel</span>
              <span className="w-20 text-start ms-1">{kulso_lift_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Külső lift ára, kezelővel"}
                  checked={kulso_lift_ar_checked}
                  onChange={() => setKulsoLiftArChecked(!kulso_lift_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Fel- és lepakolás ára</span>
              <span className="w-20 text-start ms-1">{bolti_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Bolti ár"}
                  checked={bolti_ar_checked}
                  onChange={() => setBoltiArChecked(!bolti_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Személyzeti ár</span>
              <span className="w-20 text-start ms-1">{szemelyzeti_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Személyzeti ár"}
                  checked={szemelyzeti_ar_checked}
                  onChange={() => setSzemelyzetiArChecked(!szemelyzeti_ar_checked)}
                />
              </span>
            </li>
            {/* <li className="flex justify-between gap-2">
              <span className="w-full ">Konyhaszerelő ár</span>
              <span className="w-20 text-start ms-1">{konyhaszerelo_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Konyhaszerelő ár"}
                  checked={konyhaszerelo_ar_checked}
                  onChange={() =>
                    setKonyhaszereloArChecked(!konyhaszerelo_ar_checked)
                  }
                />
              </span>
            </li> */}
            <li className="flex justify-between gap-2">
              <span className="w-full ">Küchenmonteur ár</span>
              <span className="w-20 text-start ms-1">{kuchenmonteur_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Küchenmonteur ár"}
                  checked={kuchenmonteur_ar_checked}
                  onChange={() => setKuchenmonteurArChecked(!kuchenmonteur_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Villanyszerelő ár</span>
              <span className="w-20 text-start ms-1">{villanyszerelo_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Villanyszerelő ár"}
                  checked={villanyszerelo_ar_checked}
                  onChange={() => setVillanyszereloArChecked(!villanyszerelo_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Tétel ár</span>
              <span className="w-20 text-start ms-1">{tetelAr}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Tetel ár"}
                  checked={tetal_ar_checked}
                  onChange={() => setTetelArChecked(!tetal_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Verpackungsmaterial ár</span>
              <span className="w-20 text-start ms-1">{verpackungsmaterial_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Verpackungsmaterial ár"}
                  checked={verpackungsmaterial_ar_checked}
                  onChange={() => setVerpackungsmaterialArChecked(!verpackungsmaterial_ar_checked)}
                />
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Tárolási ár</span>
              <span className="w-20 text-start ms-1">{tarolasi_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Tetel ár"}
                  checked={tarolasi_ar_checked}
                  onChange={() => setTarolasiArChecked(!tarolasi_ar_checked)}
                />
              </span>
            </li>
            {extraSerice != "" && (
              <li className="flex justify-between gap-2">
                <span className="w-full ">{extraSerice}</span>
                <span className="w-20 text-start ms-1">{extraServiceFee}</span>
                <span className="w-20 break-all text-end ms-1">EUR</span>
                <span className="flex items-center justify-end w-16">
                  <CheckBox
                    value={"Extra ár"}
                    checked={extraSericeChecked}
                    onChange={() => setExtraServiceChecked(!extraSericeChecked)}
                  />
                </span>
              </li>
            )}
          </ul>

          <hr className="my-[1.875rem]" />
          <div className="flex flex-col gap-[1.25rem] mt-[1.25rem] px-[1.625rem] text-[1rem] sm:text-[1.25rem] font-lato font-bold">
            <div className="flex justify-between gap-2">
              <span className="w-full ">Teljes ár</span>
              <span className="w-20 text-start ms-1">{teljes_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Teljes ár"}
                  checked={teljes_ar_checked}
                  onChange={() => setTeljesArChecked(!teljes_ar_checked)}
                />
              </span>
            </div>
            <div className="flex items-center justify-between gap-2">
              <span className="w-full ">
                Kedvezmény <span className="text-[#E1E1E1]">(opcionális)</span>
              </span>
              <span className="text-start ms-1">
                <InputNumbersSimple
                  id={"kedvezmeny"}
                  name={"kedvezmeny"}
                  value={kedvezmeny}
                  onChange={(e) => {
                    if (e.target.value.trim().length == 0) {
                      setKedvezmeny(0);
                    } else {
                      setKedvezmeny(parseFloat(e.target.value));
                    }
                  }}
                />
              </span>
              <span className="w-20 break-all text-end ms-1">%</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"kedvezmeny ár"}
                  checked={kedvezmeny_checked}
                  onChange={() => setKedvezmenyChecked(!kedvezmeny_checked)}
                />
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-[1.25rem] mt-[1.25rem]  text-[1rem] sm:text-[1.25rem]  font-lato font-bold">
            <div className="flex justify-between gap-2 bg-[#0655671a] text-secondary-color px-[1.625rem] py-[0.625rem]">
              <span className="w-full ">Összesen</span>
              <span className="w-20 text-start ms-1">{osszesen}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
              <span className="flex items-center justify-end w-16">
                <CheckBox
                  value={"Összesen "}
                  checked={osszesen_checked}
                  onChange={() => setOsszesenChecked(!osszesen_checked)}
                />
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-[3.125rem] w-full lg:w-1/2">
          {/*  */}
          <div className="flex flex-col gap-[1.6rem]">
            <label className="text-[1rem] font-bold text-text-primary-color leading-normal font-lato">Megjegyzés</label>
            <TextArea
              value={megjegyes}
              onChange={(e) => setMegjegyes(e.target.value)}
              placeholder={`Kezd el gépeni a feljegyzést...`}
            />
            <div className="w-full">
              <div className="grid grid-col-1 lg:grid-cols-2 mt-[3.75rem]  gap-[1.625rem] text-[1rem] sm:text-[1.25rem] font-lato font-bold">
                <div className="w-full">
                  <a target="_black" onClick={saveSummaryDataAndDownload}>
                    <ButtonOutlineFluid label={`Szállítólevél generálása`} />
                  </a>
                </div>
                <div className="w-full">
                  <a target="_black" onClick={saveSummaryDataAndDownload}>
                    <ButtonFluid label={`Ajánlat generálása`} />
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
          <div className="flex flex-col gap-[2.5rem] mt-12">
            <div className="flex justify-between">
              <h2 className="text-[1rem] font-bold text-text-primary-color leading-normal font-lato">Csatolmányok</h2>
              <h2 className="text-[1rem] underline font-bold text-text-primary-color leading-normal font-lato">
                Összes letöltése
              </h2>
            </div>
            <ul className="flex flex-col gap-[1.875rem]">
              {streetViewImages.map((image, index) => (
                <li className="flex justify-between">
                  <div className="flex items-center gap-8">
                    <img src={IconImage} className="w-8 h-8" />
                    <span>Printscreen_0{index + 1}</span>
                  </div>
                  <span
                    className="underline cursor-pointer"
                    onClick={() =>
                      downloadBase64Image(`data:image/png;base64, ${image?.image}`, `Printscreen_0${index + 1}`)
                    }
                  >
                    Letöltés
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div className="w-full ">
            <div className="grid grid-col-1 lg:grid-cols-2 mt-[3.75rem]  gap-[1.625rem] text-[1rem] sm:text-[1.25rem] font-lato font-bold">
              <div className="w-full">
                <ButtonOutlineFluid onClick={saveSummeryAndNewPropoposal} label={`Új ajánlat készítése`} />
              </div>
              <div className="w-full">
                <ButtonFluid label={`Befejezés`} onClick={saveSummeryAndFinish} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KalkulacioOsszegzes;
